module.exports = __webpack_public_path__ + "static/img/strawberry.ace6bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/strawberry.jpg
// module id = DwlA
// module chunks = 1